import React, { Component } from 'react';

class About extends Component {
    render() {
        return (
          <section className="page about">
            <div id="featuredImage" className="featuredImage bgAbout"></div>
            <h1 className="title">Über uns</h1>
            <p className="content">
              Ein Großteil der Bürger in Deutschland erbt im Laufe ihres Lebens. Was eigentlich ein Grund zur Freude ist, bringt bisweilen auch Probleme mit sich: Lange Wartezeiten, ungeklärte Verbindlichkeiten, unwillige oder noch unbekannte Miterben.
              <br /><br />
              Die ERB-Kauf GmbH bietet sich in diesen Fällen als Käufer an. Denn den wenigsten ist bekannt: <b>Erbteile können problemlos verkauft werden.</b> Hierzu ist nicht die Erlaubnis der Miterben erforderlich.
              <br /><br />
              Die Geschäftsführung der ERB-Kauf GmbH ist erfahren in der juristischen und kaufmännischen Bewertung von Erbteilkäufen und in der Lage, Ihnen ein maßgeschneidertes Angebot zu unterbreiten. <b>Die ERB-Kauf GmbH erwirbt die Anteile selbst, es wird dabei keine Provision fällig.</b>
            </p>
          </section>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/About.js